export interface WhatsNewEntry {
  hash: string;
  timestamp: string;
  title: string;
  type: 'feature' | 'fix';
  scope: string | null;
}

export interface WhatsNewFeed {
  branch: string;
  generatedAt: string;
  items: WhatsNewEntry[];
}

const whatsNewFeed: WhatsNewFeed = {
  branch: 'main',
  generatedAt: '2026-07-10T10:13:05.883Z',
  items: []
};

export default whatsNewFeed;
